module.exports = __webpack_public_path__ + "static/img_old.b8087d42.png";